import React, { FC } from 'react';
import { FiPrinter, FiTrash2 } from 'react-icons/fi';
import Component, { IconContainer } from './styles';
import { Props } from './types';

const ActionButton: FC<Props> = ({ onClick, variant, ...props }) => {
  return (
    <Component onClick={onClick} $variant={variant} {...props}>
      <IconContainer>
        {variant === 'print' ? <FiPrinter /> : <FiTrash2 />}
      </IconContainer>
    </Component>
  );
};

export default ActionButton;
